import React, { Component } from 'react';
import MyButton from '../../util/myButton';
import PropTypes from 'prop-types';

//icons
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';

//redux
import { connect } from 'react-redux';
import { likeSoundOff, unLikeSoundOff } from '../../redux/actions/dataActions';
const Link = require('react-router-dom').Link;


class LikeButton extends Component {
    likedSoundOff = () => {
        if (
            this.props.user.likes &&
            this.props.user.likes.find(
                (like) => like.soundOffId === this.props.soundOffId
            )
        ) {

            if (!this.props.soundOff.unLiked) {
                return true;
            } else {
                return false;
            }
        } else {

            return false;
        }


    };
    componentDidUpdate() {

    }

    likeSoundOff = () => {

        this.props.likeSoundOff(this.props.soundOffId);
    }

    unlikeSoundOff = () => {

        this.props.unLikeSoundOff(this.props.soundOffId);
    }

    render() {
        const { authenticated } = this.props.user;
        const likeButton = !authenticated ? (
            <Link to='/login'>
                <MyButton tip='Like'  >

                    <FavoriteBorder color='primary' />

                </MyButton>
            </Link>
        ) : (
                this.likedSoundOff() ? (
                    <MyButton tip='Unlike' onClick={this.unlikeSoundOff}>
                        <FavoriteIcon color='primary' />
                    </MyButton>
                ) : (
                        <MyButton tip='Like' onClick={this.likeSoundOff}>
                            <FavoriteBorder color='primary' />
                        </MyButton>
                    )
            );

        return likeButton;
    }
}

LikeButton.propTypes = {
    user: PropTypes.object.isRequired,
    soundOffId: PropTypes.string.isRequired,
    likeSoundOff: PropTypes.func.isRequired,
    unLikeSoundOff: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
    user: state.user,

});
const mapActionsToProps = {
    likeSoundOff,
    unLikeSoundOff
}

export default connect(mapStateToProps, mapActionsToProps,)(LikeButton);
